export default __webpack_public_path__ + "static/media/who we are.8951a283.png";